<template>
    <div>
        <input type="hidden" name="menu_data" v-bind:value='JSON.stringify(this.$root.globalData.menuMetaData)'>
        <draggable
                tag="ul" :list="this.$root.globalData.menuMetaData" class="list-group menu-group" handle=".section-handle"
        >
            <li
                    v-for='(section, key) in this.$root.globalData.menuMetaData'
            >
                <header>
                    <i class="fa fa-align-justify section-handle"></i>
                    <a href="#" @click.prevent="toggleSection(key)">Toggle section</a>
                </header>
                <div class="form-group">
                    <label>Section title</label>
                    <input type="text" v-model="section.title">
                </div>
                <button @click.prevent="addSection">Add section below</button>
                <button @click.prevent="removeSection(key)" v-if="key != 0">Remove section</button>
                <draggable
                        tag="ul" :list="section.positions" class="list-group position-group" handle=".position-handle"
                        v-show="openSections.includes(key)"
                >
            <li
                    v-for="(position, positionKey) in section.positions"
            >
                <i class="fa fa-align-justify position-handle"></i><br>
                <input type="text" v-model="position.name"><br>
                <textarea v-model="position.description" id="" cols="30" rows="2"></textarea><br>
                <input type="text" v-model="position.price">
                <footer>
                    <button @click.prevent="addPosition(key)">Add position below</button>
                    <button @click.prevent="removePosition(key, positionKey)" v-if="positionKey != 0">Remove position</button>
                </footer>
            </li>
        </draggable>
        </li>
        </draggable>
    </div>
</template>

<script>
    export default {
        name: "MenuMetaboxes",
        data: function() {
            return {
              openSections: []
            }
        },
        methods: {
            addPosition: function(section) {
                this.$root.globalData.menuMetaData[section].positions.push({name: "", description: "", price: ""})
            },
            addSection: function() {
                this.$root.globalData.menuMetaData.push({
                    title: "",
                    positions: [
                        {
                            name: "",
                            description: "",
                            price: ""
                        }
                    ]
                });
            },
            removeSection: function(sectionKey) {
                if(confirm("Are you sure you want to remove this section?"))
                    this.$root.globalData.menuMetaData = this.$root.globalData.menuMetaData.filter( (el, key) => { return key !== sectionKey } );
            },
            removePosition: function(sectionKey, positionKey)  {
                if(confirm("Are you sure you want to remove this position?"))
                    this.$root.globalData.menuMetaData[sectionKey].positions = this.$root.globalData.menuMetaData[sectionKey].positions.filter( (el,key) => { return key !== positionKey } );
            },
            toggleSection(key) {
                if ( this.openSections.includes(key) )
                    this.openSections = this.openSections.filter( value => { return value != key } );
                else
                    this.openSections.push(key);
            }
        }
    }
</script>